'use client';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import BaseBadge, { type BaseBadgeProps } from '@/app/_components/base/badge';
import { cn } from '@/app/lib/utils/tailwindcss';

const badgeVariants = cva(
  // Base styles
  ['w-fit whitespace-nowrap rounded px-2 py-0.5 typo-body-7'],
  {
    variants: {
      variant: {
        topCollector: ['bg-badge-top-collector-bg text-badge-top-collector-text'],
        exchange: ['bg-badge-exchange-bg text-badge-exchange-text', 'p-1 min-w-[50px] text-center'],
        now: ['bg-badge-now-bg text-badge-now-text', 'p-1 min-w-[50px] text-center'],
      },
    },
    defaultVariants: {
      variant: 'topCollector',
    },
  },
);

export type BadgeProps = BaseBadgeProps & VariantProps<typeof badgeVariants>;

export default function Badge({ variant, className, ...props }: BadgeProps) {
  return <BaseBadge className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
